import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-appropriation-chargeable-code-dialog',
    templateUrl: './appropriation-chargeable-code-dialog.component.html',
    styleUrls: ['./appropriation-chargeable-code-dialog.component.css'],
    standalone: false
})
export class AppropriationChargeableCodeDialogComponent implements OnInit {

  constructor(private modalService: BsModalService, private bsModalRef: BsModalRef) { }

  ngOnInit() {
  }
  /**
   * @description closes the modal using ng bootstrap as the injector is local to the component class
   */
  closeModal() {
    this.bsModalRef.hide();
  }

}
